export default __webpack_public_path__ + "static/media/Capricorn.ca6f0a38.svg";